import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_DM_REPUTATION_LAYER_STATES = defineFcm('dm_reputation_layer_states')
	.asJson(
		createShapeNormalizer({
			type: 'array',
			shape: {
				type: 'object',
				shape: {
					state: { type: 'string' },
					cities: {
						type: 'array',
						shape: {
							type: 'string',
						},
					},
				},
			},
		}),
	)
	.withDefault([])
	.toConfig({
		owner: 'squad-capybara',
		scope: 'corgi-middle-end',
		context: 'DM Reputation layer',
		description:
			'Feature flag to hold a list of states, with cities, of decision makers for which we should call the Elections API to retrieve data',
		import: false,
		template: [
			{
				state: '',
				cities: [],
			},
		],
	});
